import React, { useState } from "react";
import { Button, Form, InputGroup, Modal } from "react-bootstrap";
import { useBlade } from "../../services/BladeProvider";
import { useFavorites } from "../../services/FavoritesProvider";

interface Props {
  onExit: () => void;
}

const FileDialog = ({ onExit }: Props) => {
  const [fileContent, setFileContent] = useState<string[]>([]);
  const { raceID } = useBlade();
  const { setAthleteInfo } = useFavorites();

  const onFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const content = e.target?.result as string;
        setFileContent(content.split(/\r\n|\n/)); // Split content by line breaks
      };
      reader.readAsText(file);
    }
  };

  const onSave = () => {
    // Handle the save logic here
    localStorage.setItem("athlete_info_" + raceID, JSON.stringify(fileContent));
    setAthleteInfo(fileContent);
    onExit();
  };

  return (
    <div
      className="modal show"
      style={{
        display: "block",
        position: "absolute",
        background: "rgb(0 0 0 / 30%)",
      }}
    >
      <Modal.Dialog>
        <Modal.Header>
          <Modal.Title>
            Choose user type (Beta - functionalities subject to change)
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="usertype-box">
        

          <Form.Group controlId="formFile" className="mb-3">
            <Form.Label>Upload File</Form.Label>
            <Form.Control type="file" onChange={onFileChange} />
          </Form.Group>
          <div style={{ maxHeight: "250px", overflow: "auto" }}>
            {fileContent && (
              <div>
                <strong>File Content:</strong>
                <pre>{fileContent.join('\n')}</pre>
              </div>
            )}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" onClick={onSave}>
            Save
          </Button>
          <Button variant="primary" onClick={onExit}>
            Exit
          </Button>
        </Modal.Footer>
      </Modal.Dialog>
    </div>
  );
};

export default FileDialog;
